export default "__VITE_ASSET__cca4b3e8__"